import { render, staticRenderFns } from "./purchase-order-normal.vue?vue&type=template&id=1e4951d4&scoped=true&"
import script from "./purchase-order-normal.vue?vue&type=script&lang=js&"
export * from "./purchase-order-normal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4951d4",
  null
  
)

export default component.exports